module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAMAAAD9GTxlAAAARVBMVEUAAADNzc3JycnKysrNzc3KysrNzc3Ly8vNzc3KysrJycnMzMzMzMzMzMzNzc3MzMzMzMzMzMzLy8vMzMzMzMzNzc3MzMx8hKa/AAAAFnRSTlMAPVFSVldXWFtcX1/W3enq9Pv8/P39OsBYIwAAAE9JREFUGNOt0DkOgEAMQ9HAsASYNYDvf1QqSCJRjrtXWfo0xDSSLgJtViY4h+a9/nrp6+tQC4D6kU9LFgD3biVbV00CQPg9zE6UnSiUYkI+zWIJzdUlL3MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/publish/go.png
// module id = 9Eus
// module chunks = 1